import React from 'react';
import { Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    backgroundColor: theme.palette.insights.noData,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const TeamProductivityNoData: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid
      className={classes.container}
      data-testid={'team-productivity-no-data-container'}
    >
      <Typography variant="body2">
        <FormattedMessage
          id={'insights.teamProductivity.chart.noDataMessage'}
        />
      </Typography>
    </Grid>
  );
};

export default React.memo(TeamProductivityNoData);
